export default "__VITE_ASSET__28ad5692__"